import React, { useState, useEffect } from "react";
import { photoUrl } from "../lib/api";

const initials = (name) =>
  (name || "?").split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();

export const Avatar = ({ name, photoPath, size = 32, className = "" }) => {
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [photoPath]);
  const url = broken ? null : photoUrl(photoPath);
  const style = { width: size, height: size, fontSize: Math.max(10, size * 0.38) };
  if (url) {
    return (
      <img
        src={url}
        alt={name}
        onError={() => setBroken(true)}
        style={style}
        className={`rounded-full object-cover bg-[#1e2c4a] shrink-0 ${className}`}
      />
    );
  }
  return (
    <div
      style={style}
      className={`rounded-full bg-[#1e2c4a] flex items-center justify-center font-bold text-slate-200 shrink-0 ${className}`}
    >
      {initials(name)}
    </div>
  );
};
